import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 2,
  class: "ftco-footer ftco-section",
  style: {
    "text-align": "center",
    "display": "block"
  }
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "row"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "col-md-12 text-center"
}, [/*#__PURE__*/_createElementVNode("p", null, " © 2023 Market-shop All Rights Reserved ")])], -1);
const _hoisted_3 = {
  class: "mobile-shortcut"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_navbar = _resolveComponent("navbar");
  const _component_membernav = _resolveComponent("membernav");
  const _component_router_view = _resolveComponent("router-view");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_config_provider = _resolveComponent("van-config-provider");
  return _openBlock(), _createBlock(_component_van_config_provider, {
    theme: "dark"
  }, {
    default: _withCtx(() => [_ctx.$route.meta.showNav ? (_openBlock(), _createBlock(_component_navbar, {
      key: 0
    })) : _createCommentVNode("", true), _ctx.$route.meta.showMemberNav ? (_openBlock(), _createBlock(_component_membernav, {
      key: 1
    })) : _createCommentVNode("", true), _createElementVNode("div", {
      class: _normalizeClass(_ctx.$route.meta.showBgi ? 'bgiBox' : '')
    }, [_createVNode(_component_router_view)], 2), _ctx.$route.meta.showFooter ? (_openBlock(), _createElementBlock("footer", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/proList'))
    }, _toDisplayString(_ctx.$t('btn.ProductSelection')), 1), _createVNode(_component_van_icon, {
      size: "16",
      name: "weapp-nav"
    }), _createElementVNode("a", {
      onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('/proOEM'))
    }, _toDisplayString(_ctx.$t('btn.SalesChannel')), 1)])])) : _createCommentVNode("", true)]),
    _: 1
  });
}